<template>
    <div style="padding: 0 !important; height: 100% !important;">
        <v-container class="login-container" fluid>
            <v-row style="height: 100% !important;">
                <v-col class="pane-padding" cols="5">
                    <v-row style="height: 15%">
                        <v-col>
                            <p class="quote">{{ this.currentQuote.quote }}</p>
                            <p class="by"><i>{{ this.currentQuote.by }}</i></p>
                        </v-col>
                    </v-row>
                    <v-row style="height: 85%" align="end">
                        <v-col lg="10" xl="10">
                            <div>
                                <v-form v-model="valid">
                                    <v-img class="mb-2" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" max-width="250px" contain/>
                                    <p style="color: #585a61">{{ $t('mainPhrase') }}</p>
                                    <br>
                                    <v-text-field :label="$t('form.username.label')"  v-model="username" v-on:keyup.enter="submitForm" outlined/>
                                    <v-text-field :label="$t('form.password.label')" :type="showPassword ? 'text' : 'password'"
                                                  v-model="password" v-on:keyup.enter="submitForm" outlined>
                                      <v-icon slot="append" class="icon" color="black" @click="showPassword = !showPassword">
                                        {{ (showPassword) ? 'fa-eye' : 'fa-eye-slash' }}
                                      </v-icon>
                                    </v-text-field>
                                    <div class="d-flex align-center justify-end text-end">
                                        <router-link to="/reset-password" class="ml-7 my-n3" style="color: #58595e">{{ $t('lostPassword') }}</router-link>
                                    </div>
                                    <br>
                                    <v-btn class="button-login mr-5" :loading="loadingLoginAttempt" @click="submitForm">{{ $t('login') }}</v-btn>
                                    <v-btn class="button-signup" @click="signUp">{{ $t('registerNow') }}</v-btn>
                                </v-form>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="login-image" cols="7"></v-col>
            </v-row>
        </v-container>

        <!--Error dialog!-->
        <v-overlay v-model="errorDialog">
          <LoginError :type="errorType" :email="username" :password="password" @close="errorDialog = false"/>
        </v-overlay>
    </div>
</template>

<script>
    import Quotes from '../quotes';
    import { mapMutations } from 'vuex';
    import Repository from '../../../repositories/auth';
    import LoginError from "@/views/Login/components/LoginError";

    export default {
        name: "Login",
        components: {LoginError},
        mounted() {
            this.getQuote();
            this.deleteWhitelabel();
        },
        watch:{
            // eslint-disable-next-line no-unused-vars
            $route(to, from){
                this.getQuote();
            },
            '$i18n.locale': function(){
                this.getQuote();
            }
        },
        data() {
            return {
                currentQuote: {
                    quote: 'Risk Management is the key for the 99% successful traders. The remaining 1% are just lucky ones',
                    by: 'Camilo Tobar'
                },
                showPassword: false,
                valid: false,
                username: '',
                password: '',
                usernameRule: [
                    u => !!u || this.$t('form.username.rule'),
                ],
                passwordRule: [
                    p => !!p || this.$t('form.password.rule'),
                ],
                loadingLoginAttempt: false,

                // Error
                errorDialog: false,
                errorType: '',
            };
        },
        methods: {
            getQuote() {
                this.currentQuote = (this.$i18n.locale === "en")?Quotes.en[(Math.random() * 7).toFixed(0)]:Quotes.es[(Math.random() * 7).toFixed(0)];
            },
            ...mapMutations(['setToken', 'setUser', 'setUserDetails', 'setPreferredLanguage']),
            async submitForm(){
                this.loadingLoginAttempt = true;
                if(this.valid){
                   Repository.login(this.username, this.password).then(async (response) => {
                       if(response.status < 250)
                       {
                           this.setToken(`Bearer ${response.data.id_token}`);
                           await Repository.getUser().then((response) => {this.setUser(response.data);});
                           await Repository.getLanguage().then((response) => { this.setPreferredLanguage(response.data); });
                           await Repository.getUserDetails().then((response) => { this.setUserDetails(response.data); });
                           await Repository.analyzeNewUserLogin();
                           await this.$router.push('/dashboard');
                       }
                   }).catch((error) => {
                       this.loadingLoginAttempt = false;
                       this.errorDialog = true;
                       if(error.response.data.status === 401 && String(error.response.data.detail).endsWith('not activated'))
                          this.errorType = 'NOT_ACTIVATED';
                       else if(error.response.data.status === 401)
                          this.errorType = 'NOT_CREDENTIALS';
                       else
                          this.errorType = 'UNEXPECTED';
                   });
                }else
                   alert(this.$t('alertMessage'));
            },
            signUp() {
                this.$router.push('/register');
            },
            ...mapMutations(['resetWhitelabel']),
            deleteWhitelabel(){
                this.resetWhitelabel();
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "../../../global";

    .v-input__icon--append .v-icon {
      border: none !important;
    }

    .v-input__icon--append .v-icon:hover {
      border: none !important;
    }

    .login-container {
        height: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    .quote {
        color: $text-color;
        font-size: 17px;
    }
    .by {
        color: $text-color;
        font-size: 15px;
    }
    .pane-padding {
        padding: 2.5% 4% 2.5% 5%;
    }
    .button-login {
        background-color: $black-color !important;
        color: $white-color !important;
        padding: 5% 7.7% !important;
    }
    .button-signup {
        background-color: $white-color !important;
        color: $black-color !important;
        padding: 5% 4.2% !important;
    }
    .login-image{
        padding: 0;
        background-color: #111111;
        background-image: url("https://swiset.com/wp-content/uploads/2020/05/Automatic-Trading-Journal-in-Swiset.png");
        background-repeat: no-repeat;
        background-size: contain, cover;
        background-position: right;
    }
</style>


<i18n>
{
  "en": {
      "mainPhrase": "Manage, boost and fund your trading.",
      "lostPassword": "Lost your password?",
      "login": "Login",
      "registerNow": "Register Now",
      "alertMessage": "One or more mandatory fields are not filled",

      "form":{
          "username":{
              "label": "Your email or username",
              "rule": "Username is required"
          },
          "password":{
              "label": "Your password",
              "rule": "Password is required"
          }
      }
  },
  "es":{
      "mainPhrase": "Gestiona, impulsa y fondea tu trading.",
      "lostPassword": "¿Olvidaste tu contraseña?",
      "login": "Ingresar",
      "registerNow": "Registrate ahora",
      "alertMessage": "Uno o más campos obligatorios no estan completos",

      "form":{
          "username":{
              "label": "Tu email o nombre de usuario",
              "rule": "El dato es obligatorio"
          },
          "password":{
              "label": "Tu contraseña",
              "rule": "La contraseña es obligatoria"
          }
      }
  }
}
</i18n>
